import React, { useState } from 'react';
import BiteListOptions from './BiteList/BiteListOptions';
import PEPOptions from './PEP/PEPOptions';
import DebarredOptions from './Debarred/DebarredOptions';
import { Button } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import ESGOptions from './ESGReg/ESGOptions';

interface IBiteFormProps {
  selectedIndex: string;
  formValues: any;
  setFormValues: any;
  biteListPrimaryOpts: any;
  setBiteListPrimaryOpts: any;
  invDomainOpts: any;
  setInvDomainOpts: any;
  countryOpts: any;
  setCountryOpts: any;
  entityTypeOpts: any;
  setEntityTypeOpts: any;
  govtAgencyOpts: any;
  setGovtAgencyOpts: any;
  listNameOpts: any;
  setListNameOpts: any;
  stateOpts: any;
  setStateOpts: any;
  pepCountryOpts: any;
  setPepCountryOpts: any;
  getInitialResults: any;
  countryData: any;
  queryBiteList: any;
  pageNum: number;
  isInteractionDisabled?: boolean;
}

const BiteListForm: React.FC<IBiteFormProps> = ({
  pepCountryOpts,
  setPepCountryOpts,
  biteListPrimaryOpts,
  queryBiteList,
  pageNum,
  countryData,
  getInitialResults,
  selectedIndex,
  formValues,
  setFormValues,
  invDomainOpts,
  countryOpts,
  setInvDomainOpts,
  setCountryOpts,
  setGovtAgencyOpts,
  listNameOpts,
  setListNameOpts,
  stateOpts,
  setStateOpts,
  entityTypeOpts,
  setEntityTypeOpts,
  isInteractionDisabled = false,
}) => {
  const [ toClear, setToClear ] = useState(false);
  const clearFormAndResults = async() => {
    if (isInteractionDisabled) {
      return;
    }
    setFormValues({
      searchValue: '',
      country: [],
      invDomain: [],
      listName: [],
      entityCountry: [],
      entityType: [],
      govtAgency: [],
      state: [],
      fuzziness: 0,
    });
    setInvDomainOpts({ isLoading: true, data: {} });
    setCountryOpts({ isLoading: true, data: {} });
    setListNameOpts({ isLoading: true, data: {} });
    setEntityTypeOpts({ isLoading: true, data: {} });
    setGovtAgencyOpts({ isLoading: true, data: {} });
    setPepCountryOpts({ isLoading: true, data: {} });
    setStateOpts({ isLoading: true, data: {} });
    setToClear(true);
    await getInitialResults();
    setToClear(false);
  };

  const handleEnterPress = (e: any) => {
    if ((e.key === 'Enter' || e.which === 13) && !isInteractionDisabled) {
      queryBiteList(formValues, pageNum);
    }
  };

  return (
    <div className='watchlist-form'>
      <div className='watchlist-search'>
        <input
          id='searchVal'
          placeholder='Search here...'
          type='text'
          className='wl-search-input'
          name='searchValue'
          value={formValues.searchValue}
          onChange={(e) =>
            setFormValues({
              ...formValues,
              searchValue: e.target.value,
            })
          }
          onKeyUp={handleEnterPress}
        />
        <Button
          className='wl-search-btn'
          disabled={isInteractionDisabled}
          onClick={() => queryBiteList(formValues, pageNum)}
        >
          {isInteractionDisabled && <LockIcon fontSize='small' sx={{ mr: 0.5 }} />}
          Search
        </Button>
      </div>
      <div className='filters-header'>
        <div className='filters-text'>Advanced Filters</div>
        <div
          className='clear-module-form'
          onClick={clearFormAndResults}
          style={{
            cursor: isInteractionDisabled ? 'not-allowed' : 'pointer',
            opacity: isInteractionDisabled ? 0.7 : 1,
          }}
        >
          <div className='clear-module-text'>Clear All</div>
          <div className='clear-form-icon'>
            <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
              <path d='M11.25 5.13281C11.25 5.13281 12.1064 4.71094 9 4.71094C7.88748 4.71094 6.79995 5.04084 5.87492 5.65892C4.94989 6.277 4.22892 7.15551 3.80318 8.18334C3.37744 9.21118 3.26604 10.3422 3.48309 11.4333C3.70013 12.5245 4.23586 13.5267 5.02253 14.3134C5.8092 15.1001 6.81148 15.6358 7.90262 15.8529C8.99376 16.0699 10.1248 15.9585 11.1526 15.5328C12.1804 15.107 13.0589 14.386 13.677 13.461C14.2951 12.536 14.625 11.4485 14.625 10.3359' stroke='var(--text-primary-white)' strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round'/>
              <path d='M9 2.03906L11.8125 4.85156L9 7.66406' stroke='var(--text-primary-white)' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
        </div>
      </div>
      <form style={{ pointerEvents: isInteractionDisabled ? 'none' : 'auto' }}>
        {selectedIndex === 'Risk Insights' && (
          <BiteListOptions
            formValues={formValues}
            setFormValues={setFormValues}
            selectedIndex={selectedIndex}
            biteListPrimaryOpts={biteListPrimaryOpts}
            setCountryOpts={setCountryOpts}
            countryOpts={countryOpts}
            invDomainOpts={invDomainOpts}
            setInvDomainOpts={setInvDomainOpts}
            countryData={countryData}
            toClear={toClear}
          />
        )}
        {selectedIndex === 'PEP' && (
          <PEPOptions
            formValues={formValues}
            setFormValues={setFormValues}
            selectedIndex={selectedIndex}
            biteListPrimaryOpts={biteListPrimaryOpts}
            pepCountryOpts={pepCountryOpts}
            setPepCountryOpts={setPepCountryOpts}
            entityTypeOpts={entityTypeOpts}
            setEntityTypeOpts={setEntityTypeOpts}
            countryData={countryData}
            toClear={toClear}
          />
        )}
        {selectedIndex === 'Debarred' && (
          <DebarredOptions
            formValues={formValues}
            setFormValues={setFormValues}
            selectedIndex={selectedIndex}
            biteListPrimaryOpts={biteListPrimaryOpts}
            listNameOpts={listNameOpts}
            setListNameOpts={setListNameOpts}
            countryOpts={countryOpts}
            setCountryOpts={setCountryOpts}
            countryData={countryData}
            stateOpts={stateOpts}
            setStateOpts={setStateOpts}
            toClear={toClear}
          />
        )}
        {(selectedIndex === 'FF Labor' ||
          selectedIndex === 'ESG Registrations') && (
          <ESGOptions
            formValues={formValues}
            setFormValues={setFormValues}
            selectedIndex={selectedIndex}
            biteListPrimaryOpts={biteListPrimaryOpts}
            listNameOpts={listNameOpts}
            setListNameOpts={setListNameOpts}
            countryOpts={countryOpts}
            setCountryOpts={setCountryOpts}
            countryData={countryData}
            toClear={toClear}
          />
        )}
      </form>
    </div>
  );
};

export default BiteListForm;
